import { API } from "src/server/api";
import md5 from "md5";
import { decodeToken } from "src/libs/jwt";

class AuthApi {
  async signIn(request) {
    const { username, password } = request;

    // call authenticate
    const response = await API.post("auth/login", {
      username: username,
      password: password,
    });

    return new Promise((resolve, reject) => {
      try {
        var token = response.data.token;
        var paths = response.data.paths;
        resolve({ token, paths });
      } catch (err) {
        console.error("[Auth Api]: ", err);
        reject(new Error("Internal server error"));
      }
    });
  }

  async signOut(request) {
    const { userId } = request;

    // call authenticate
    const response = await API.post("auth/logout", {
      userId: userId,
    });

    return new Promise((resolve, reject) => {
      try {
        var status = response.data.status;
        resolve({ status });
      } catch (err) {
        console.error("[Auth Api]: ", err);
        reject(new Error("Internal server error"));
      }
    });
  }

  async me(request) {
    const { token } = request;

    let user = "";
    const userFromToken = decodeToken(token);

    try {
      const response = await API.post("auth/user", {
        userId: userFromToken.id,
      });

      user = response.data.user;
    } catch (error) {
      console.error(error);
    }

    return new Promise((resolve, reject) => {
      try {
        const emailHash = md5(user.username);

        resolve({
          id: user.id,
          avatar:
            "https://www.gravatar.com/avatar/" + emailHash + "?d=identicon",
          email: user.username,
          name: user.fullName,
          role: user.role,
          isExpired: userFromToken.isExpired,
          passwordChanged: user.passwordChanged,
        });
      } catch (err) {
        console.error("[Auth Api]: ", err);
        reject(new Error("Internal server error"));
      }
    });
  }
}

export const authApi = new AuthApi();
